import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../data/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("wedowedo_lang") || "en"; }
    catch { return "en"; }
  });

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    try { localStorage.setItem("wedowedo_lang", newLang); } catch {}
  }, []);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let value = translations[lang];
      for (const key of keys) {
        if (value === undefined) return path;
        value = value[key];
      }
      return value || path;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
